var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5H3.33333C2.8731 2.5 2.5 2.8731 2.5 3.33333V7.5C2.5 7.96025 2.8731 8.33333 3.33333 8.33333H7.5C7.96025 8.33333 8.33333 7.96025 8.33333 7.5V3.33333C8.33333 2.8731 7.96025 2.5 7.5 2.5Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.6667H3.33333C2.8731 11.6667 2.5 12.0397 2.5 12.5V16.6667C2.5 17.1269 2.8731 17.5 3.33333 17.5H7.5C7.96025 17.5 8.33333 17.1269 8.33333 16.6667V12.5C8.33333 12.0397 7.96025 11.6667 7.5 11.6667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 2.5H12.5C12.0397 2.5 11.6666 2.8731 11.6666 3.33333V7.5C11.6666 7.96025 12.0397 8.33333 12.5 8.33333H16.6666C17.1269 8.33333 17.5 7.96025 17.5 7.5V3.33333C17.5 2.8731 17.1269 2.5 16.6666 2.5Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 11.6667H12.5C12.0397 11.6667 11.6666 12.0397 11.6666 12.5V16.6667C11.6666 17.1269 12.0397 17.5 12.5 17.5H16.6666C17.1269 17.5 17.5 17.1269 17.5 16.6667V12.5C17.5 12.0397 17.1269 11.6667 16.6666 11.6667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5105af9a174d1e3d4bfb4ee424fad061.svg";
export { ForwardRef as ReactComponent };